import { createApp } from 'vue'
import { ConfigProvider } from 'vant';
import App from './App.vue'
import store from './store'
import bootstrap from './bootstrap'
import { initRouter } from '@/router'
import 'vant/es/toast/style';
import 'vant/es/dialog/style';
import { showNotify } from 'vant';
import 'vant/es/notify/style';
import 'vant/es/image-preview/style';

var app = createApp(App)
app.config.globalProperties.$message = {
  success(content) {
    showNotify({
      message: content,
      type: 'success'
    })
  },
  error(content) {
    showNotify({
      message: content,
      type: 'danger'
    })
  },
  warning(content) {
    showNotify({
      message: content,
      type: 'warning'
    })
  },
  info(content) {
    showNotify({
      message: content,
      type: 'primary'
    })
  }
}

const router = initRouter()

bootstrap({ router, store, i18n: null, message: app.config.globalProperties.$message })

app.use(ConfigProvider).use(store).use(router).mount('#app')
